<aside class="relative">
  <sc-msisdn-preview></sc-msisdn-preview>
  <div class="lines-top-right-black"></div>

  <nav class="font-light text-black divide-y menu z-10 relative sidebar-links">
    @for (linkGroup of linkNavigationList(); track $index) {
      <a
        class="px-4 h-14 flex items-center justify-between cursor-pointer bg-white hover:bg-secondaryRed"
        [class.rounded-b]="$last"
        [ngClass]="{
          '!bg-primaryRed text-white font-semibold': isParentLinkActive(linkGroup),
        }"
        (click)="updatePath(linkGroup.path)"
        [routerLink]="
          this.isLimited() && !linkGroup.showWhenLimited && linkGroup.hasActiveSubLinks
            ? null
            : linkGroup.path
        "
      >
        {{ linkGroup.label | scTranslate | async }}
        @if (linkGroup.subLinks.length) {
          <div class="flex items-center">
            <sc-svg
              name="arrow-down"
              size="w-5 h-5"
              class="transform"
              [class.rotate-180]="linkGroup.path === currentPath()"
            ></sc-svg>
          </div>
        }
      </a>
      @if (linkGroup.subLinks.length && isSubLinkActive(linkGroup)) {
        <ul [attr.aria-label]="'submenu for ' + linkGroup.path">
          @for (sublink of linkGroup.subLinks; track $index) {
            <li>
              <a
                [routerLink]="sublink.path"
                routerLinkActive="border-l-[red] font-semibold "
                class="border-l-2 h-14 flex items-center pl-3.5 bg-[#F0DBDB] hover:bg-secondaryRed"
              >
                {{ sublink.label | scTranslate | async }}
              </a>
            </li>
          }
        </ul>
      }
    }
  </nav>

  <div class="lines-bottom-left-white"></div>
</aside>
